import Plugin from '../core/Plugin';

/**
 * LinkPlugin - Handles link insertion
 */
class LinkPlugin extends Plugin {
  constructor(editor, options = {}) {
    super(editor, options);
    this.name = 'Link';
  }

  executeCommand(command) {
    if (command === 'createLink') {
      // Use the editor's link modal instead of prompt()
      this.editor.insertLink();
    }
  }

  getMetadata() {
    return {
      name: 'Links',
      version: '1.0.0',
      description: 'Provides link insertion functionality',
      author: 'AtlaraFirm',
    };
  }
}

export default LinkPlugin;
